/* The 404 page and the goodbye page after deleting an account. */
import { WEB_ROUTES } from '@pathabroad/core/browser';
import { useT } from '../app/i18n';
import { Link } from '../app/nav';
import { useSession } from '../app/session';
import { PageHeader } from '../app/ui';

export function NotFound() {
  const { t } = useT();
  const { session } = useSession();
  return (
    <div className="narrow">
      <PageHeader title={t('nf.title')} lead={t('nf.text')} />
      <p className="linkrow">
        <Link to="/">{t('common.home')}</Link>
        {session.status === 'in' && <Link to={WEB_ROUTES.account}>{t('nav.account')}</Link>}
        <a href={WEB_ROUTES.planner}>{t('nav.planner')}</a>
      </p>
    </div>
  );
}

export function Goodbye() {
  const { t } = useT();
  const { setFarewell } = useSession();
  return (
    <div className="narrow">
      <PageHeader title={t('bye.title')} lead={t('bye.text')} />
      <p><Link to="/" onClick={() => setFarewell(false)}>{t('common.home')}</Link></p>
    </div>
  );
}
